/** Module store for reCAPTCHA response (legacy parity with class SignUp). */
let recaptchaResponse;

export function setSignUpRecaptchaResponse(response) {
  recaptchaResponse = response;
}

export function clearSignUpRecaptchaResponse() {
  recaptchaResponse = undefined;
}

export function getSignUpRecaptchaResponse() {
  return recaptchaResponse;
}
